import { pagetypeConstants, alertConstants, userConstants } from "../constants";
import { pagetypeService } from "../services";
import { alertActions } from "./alert.actions.js";

export const pagetypeActions = {
  getList,
  getPageTypeTree,
  createPagetype,
  createPageGroup,
  updatePagetypeList,
  getUngroupedPagetypeId,
  getUnclassifiedPagetypeId,
  getPageTypeInspection,
  setCurrentPageType,
  getPageGroups,
  getPageTypesForGroup,
  addPageTypeForGroup,
  removePageTypeForGroup,
};

function getList(org_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching pagetypes..."));
    dispatch(listRequest(org_id));

    pagetypeService.getList(org_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(org_id) {
    return { type: pagetypeConstants.PAGETYPE_LIST_REQUEST, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: pagetypeConstants.PAGETYPE_LIST_SUCCESS, list };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_LIST_FAILURE, message };
  }
}

function getPageTypeTree(org_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching page type tree..."));
    dispatch(treeRequest(org_id));

    pagetypeService.getPageTypeTree(org_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function treeRequest(org_id) {
    return { type: pagetypeConstants.PAGETYPE_TREE_REQUEST, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(tree) {
    return { type: pagetypeConstants.PAGETYPE_TREE_SUCCESS, tree };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_TREE_FAILURE, message };
  }
}

function getPageGroups(org_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching pagegroups..."));
    dispatch(listRequest(org_id));

    pagetypeService.getGroupList(org_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(org_id) {
    return { type: pagetypeConstants.PAGETYPE_GROUP_LIST_REQUEST, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: pagetypeConstants.PAGETYPE_GROUP_LIST_SUCCESS, list };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_GROUP_LIST_FAILURE, message };
  }
}

function getPageTypesForGroup(org_id, group_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching page types for group..."));
    dispatch(listRequest(group_id));

    pagetypeService.getPageTypesForGroup(org_id, group_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(org_id) {
    return { type: pagetypeConstants.PAGETYPE_FOR_GROUP_LIST_REQUEST, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: pagetypeConstants.PAGETYPE_FOR_GROUP_LIST_SUCCESS, list };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_FOR_GROUP_LIST_FAILURE, message };
  }
}

function addPageTypeForGroup(org_id, group_id, type_id) {
  return (dispatch) => {
    dispatch(createAlert("adding pagetype to group..."));
    dispatch(createRequest(org_id, group_id, type_id));

    pagetypeService.addPageTypeForGroup(org_id, group_id, type_id).then(
      (pagetype) => {
        dispatch(refreshToken(pagetype.newToken));
        dispatch(clearAlert());
        dispatch(success(pagetype));
        dispatch(getPageTypesForGroup(org_id, group_id));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        dispatch(alertActions.error("unable to create pagetype"));
      }
    );
  };
  function createAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function createRequest(org, group, pagetype) {
    return {
      type: pagetypeConstants.PAGETYPE_FOR_GROUP_ADD_REQUEST,
      org,
      group,
      pagetype,
    };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(page_type) {
    return {
      type: pagetypeConstants.PAGETYPE_FOR_GROUP_ADD_SUCCESS,
      page_type,
    };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_FOR_GROUP_ADD_FAILURE, message };
  }
}

function removePageTypeForGroup(org_id, group_id, type_id) {
  return (dispatch) => {
    dispatch(createAlert("removing pagetype from group..."));
    dispatch(removeRequest(org_id, group_id, type_id));

    pagetypeService.removePageTypeForGroup(org_id, group_id, type_id).then(
      (pagetype) => {
        dispatch(refreshToken(pagetype.newToken));
        dispatch(clearAlert());
        dispatch(success(pagetype));
        dispatch(getPageTypesForGroup(org_id, group_id));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        dispatch(alertActions.error("unable to remove pagetype"));
      }
    );
  };
  function createAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function removeRequest(org, group, pagetype) {
    return {
      type: pagetypeConstants.PAGETYPE_FOR_GROUP_REMOVE_REQUEST,
      org,
      group,
      pagetype,
    };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(page_type) {
    return {
      type: pagetypeConstants.PAGETYPE_FOR_GROUP_REMOVE_SUCCESS,
      page_type,
    };
  }
  function failure(message) {
    return {
      type: pagetypeConstants.PAGETYPE_FOR_GROUP_REMOVE_FAILURE,
      message,
    };
  }
}

function createPagetype(page_type) {
  return (dispatch) => {
    dispatch(createAlert("creating new pagetype..."));
    dispatch(createRequest(page_type));

    pagetypeService.createPagetype(page_type).then(
      (pagetype) => {
        dispatch(refreshToken(pagetype.newToken));
        dispatch(clearAlert());
        dispatch(success(pagetype));
        dispatch(getList(page_type.org_id));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        dispatch(alertActions.error("unable to create pagetype"));
      }
    );
  };
  function createAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function createRequest(page_type) {
    return { type: pagetypeConstants.PAGETYPE_CREATE_REQUEST, page_type };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(page_type) {
    return { type: pagetypeConstants.PAGETYPE_CREATE_SUCCESS, page_type };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_CREATE_FAILURE, message };
  }
}

function createPageGroup(page_type) {
  return (dispatch) => {
    dispatch(createAlert("creating new page group..."));
    dispatch(createRequest(page_type));

    pagetypeService.createPageGroup(page_type).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
        dispatch(getList(page_type.org_id));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        dispatch(alertActions.error("unable to create pagetype"));
      }
    );
  };
  function createAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function createRequest(page_type) {
    return { type: pagetypeConstants.PAGETYPE_CREATE_GROUP_REQUEST, page_type };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: pagetypeConstants.PAGETYPE_CREATE_GROUP_SUCCESS, list };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_CREATE_GROUP_FAILURE, message };
  }
}

function updatePagetypeList(list, org_id) {
  return (dispatch) => {
    dispatch(createAlert("updating page groupings..."));
    dispatch(updateRequest(list));

    pagetypeService.updatePagetypeList(list, org_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
        dispatch(getList(org_id));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        dispatch(alertActions.error("unable to update page groupings."));
      }
    );
  };
  function createAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function updateRequest(list) {
    return { type: pagetypeConstants.PAGETYPE_UPDATE_REQUEST, list };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: pagetypeConstants.PAGETYPE_UPDATE_SUCCESS, list };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_UPDATE_FAILURE, message };
  }
}

function getUngroupedPagetypeId(org_id) {
  return (dispatch) => {
    dispatch(createAlert("retrieving page grouping information..."));
    dispatch(getRequest(org_id));

    pagetypeService.getUngroupedPagetypeId(org_id).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response.id));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to retrieve page grouping information'));*/
      }
    );
  };
  function createAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function getRequest(org_id) {
    return { type: pagetypeConstants.PAGETYPE_UNGROUPED_ID_REQUEST, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(id) {
    return { type: pagetypeConstants.PAGETYPE_UNGROUPED_ID_SUCCESS, id };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_UNGROUPED_ID_FAILURE, message };
  }
}

function getUnclassifiedPagetypeId(org_id) {
  return (dispatch) => {
    dispatch(createAlert("retrieving page grouping information..."));
    dispatch(getRequest(org_id));

    pagetypeService.getUnclassifiedPagetypeId(org_id).then(
      (id) => {
        dispatch(clearAlert());
        dispatch(success(id));
      },
      (error) => {
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to retrieve page grouping information'));*/
      }
    );
  };
  function createAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function getRequest(org_id) {
    return { type: pagetypeConstants.PAGETYPE_UNCLASSIFIED_ID_REQUEST, org_id };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(id) {
    return { type: pagetypeConstants.PAGETYPE_UNCLASSIFIED_ID_SUCCESS, id };
  }
  function failure(message) {
    return {
      type: pagetypeConstants.PAGETYPE_UNCLASSIFIED_ID_FAILURE,
      message,
    };
  }
}

function getPageTypeInspection(org_id) {
  return (dispatch) => {
    dispatch(createAlert("retrieving page types detail..."));
    dispatch(getRequest(org_id));

    pagetypeService.getPageTypeInspection(org_id).then(
      (list) => {
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to retrieve page grouping information'));*/
      }
    );
  };
  function createAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function getRequest(org_id) {
    return { type: pagetypeConstants.PAGETYPE_INSPECTION_REQUEST };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: pagetypeConstants.PAGETYPE_INSPECTION_SUCCESS, list };
  }
  function failure(message) {
    return { type: pagetypeConstants.PAGETYPE_INSPECTION_FAILURE, message };
  }
}

function setCurrentPageType(page_type_id) {
  return (dispatch) => {
    dispatch(setCurrentPageType(page_type_id));
  };

  function setCurrentPageType(page_type_id) {
    return {
      type: pagetypeConstants.PAGETYPE_SET_CURRENT_PAGETYPE,
      page_type_id,
    };
  }
}
